import { useState, useRef, useEffect } from 'react';
import { WebsocketClientApp } from '@/app';
export function useVoiceChat({ onUserTranscript, onBotTranscript, agenticMode }) {
    const [isListening, setIsListening] = useState(false);
    const [isVoiceConnected, setIsVoiceConnected] = useState(false);
    const recognitionRef = useRef(null);
    const voiceClientRef = useRef(null);
    const botResponseRef = useRef('');
    const currentBotMessageIdRef = useRef(null);
    useEffect(() => {
        if (!agenticMode) {
            const SpeechRecognitionAPI = window.SpeechRecognition || window.webkitSpeechRecognition;
            if (SpeechRecognitionAPI) {
                recognitionRef.current = new SpeechRecognitionAPI();
                recognitionRef.current.continuous = false;
                recognitionRef.current.interimResults = false;
                recognitionRef.current.lang = 'en-US';
                recognitionRef.current.onresult = (event) => {
                    const transcript = event.results[0][0].transcript;
                    setIsListening(false);
                    onUserTranscript(transcript, true);
                };
                recognitionRef.current.onend = () => setIsListening(false);
                recognitionRef.current.onerror = () => setIsListening(false);
            }
        }
        return () => {
            recognitionRef.current?.abort();
        };
    }, [agenticMode, onUserTranscript]);
    useEffect(() => {
        return () => {
            voiceClientRef.current?.disconnect();
        };
    }, []);
    const connectVoice = async () => {
        try {
            const voiceCallbacks = {
                onUserTranscript: (text, isFinal) => {
                    console.log('User transcript:', text, 'final:', isFinal);
                    if (isFinal && text.trim()) {
                        onUserTranscript(text, isFinal);
                        const botMessageId = `voice-bot-${Date.now()}`;
                        currentBotMessageIdRef.current = botMessageId;
                        botResponseRef.current = '';
                        onBotTranscript('...', botMessageId);
                    }
                },
                onBotTranscript: (text) => {
                    console.log('Bot transcript:', text);
                    botResponseRef.current += text;
                    const fullResponse = botResponseRef.current;
                    let messageId = currentBotMessageIdRef.current;
                    if (!messageId) {
                        messageId = `voice-bot-${Date.now()}`;
                        currentBotMessageIdRef.current = messageId;
                    }
                    onBotTranscript(fullResponse, messageId);
                },
                onConnected: () => {
                    console.log('Voice connected callback');
                    setIsVoiceConnected(true);
                },
                onDisconnected: () => {
                    console.log('Voice disconnected callback');
                    setIsVoiceConnected(false);
                    currentBotMessageIdRef.current = null;
                },
                onError: (error) => {
                    console.error('Voice error:', error);
                },
            };
            if (!voiceClientRef.current) {
                console.log('Creating new WebsocketClientApp with callbacks');
                voiceClientRef.current = new WebsocketClientApp(voiceCallbacks);
            }
            else {
                voiceClientRef.current.setCallbacks(voiceCallbacks);
            }
            console.log('Connecting to voice backend...');
            await voiceClientRef.current.connect();
            console.log('Voice connected');
            setIsVoiceConnected(true);
        }
        catch (error) {
            console.error('Failed to connect voice:', error);
        }
    };
    const disconnectVoice = async () => {
        await voiceClientRef.current?.disconnect();
        setIsVoiceConnected(false);
        currentBotMessageIdRef.current = null;
    };
    const toggleBrowserSpeechRecognition = () => {
        if (isListening) {
            recognitionRef.current?.stop();
        }
        else {
            recognitionRef.current?.start();
            setIsListening(true);
        }
    };
    return {
        isListening,
        isVoiceConnected,
        connectVoice,
        disconnectVoice,
        toggleBrowserSpeechRecognition,
    };
}
